import { LocalStorageKey } from 'shared/constants/localStorage'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type AppOpeningMode = 'windowed' | 'maximized' | 'detached'
export type ShortcutClickMethod = 'single' | 'double'

export type PreferencesState = {
  defaultAppOpeningMode: AppOpeningMode
  shortcutClickMethod: ShortcutClickMethod
  desktopSessionInUrlEnabled: boolean
  cachingEnabled: boolean
  cachedAppIds: string[]
}

type PreferencesActions = {
  setDefaultAppOpeningMode: (mode: AppOpeningMode) => void
  setShortcutClickMethod: (method: ShortcutClickMethod) => void
  setDesktopSessionInUrlEnabled: (enabled: boolean) => void
  setCachingEnabled: (enabled: boolean) => void
  setCachedAppIds: (ids: string[]) => void
}

type PreferencesStore = PreferencesState & PreferencesActions

export const usePreferencesStore = create<PreferencesStore>()(
  persist(
    set => ({
      defaultAppOpeningMode: 'windowed',
      shortcutClickMethod: 'single',
      desktopSessionInUrlEnabled: true,
      cachingEnabled: true,
      cachedAppIds: ['gdpr'],
      setDefaultAppOpeningMode: mode => set({ defaultAppOpeningMode: mode }),
      setShortcutClickMethod: method => set({ shortcutClickMethod: method }),
      setDesktopSessionInUrlEnabled: enabled =>
        set({ desktopSessionInUrlEnabled: enabled }),
      setCachingEnabled: enabled => set({ cachingEnabled: enabled }),
      setCachedAppIds: ids => set({ cachedAppIds: ids })
    }),
    {
      name: LocalStorageKey.PREFERENCES
    }
  )
)
